/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import SocialLogin from "mutation/SocialLogin";
import AuthenticationContext from "state/authentication";
import {getAnalytics, logEvent} from "firebase/analytics";

const GoogleSignInButton: React.FC = () => {
    const [loading, setLoading] = React.useState(false);
    const authenticationContext = React.useContext(AuthenticationContext);
    const handleCredentialResponse = React.useCallback(async (e) => {
        const analytics = getAnalytics();
        logEvent(analytics, 'google_sign_in_response')
        setLoading(true)
        const credential = e.credential;
        const accessToken = await SocialLogin(credential, "GOOGLE");
        authenticationContext.setAccessToken(accessToken);
        setLoading(false)
    }, [authenticationContext]);

    const executeGoogleSetup = React.useCallback((google: any) => {
        const analytics = getAnalytics();
        logEvent(analytics, 'google_sign_in_started')
        google.accounts.id.initialize({
            client_id: "490599662599-5kjfucb2mu2s9sm1c1qu40cceungaeg5.apps.googleusercontent.com",
            callback: handleCredentialResponse
        });
        google.accounts.id.renderButton(
            document.getElementById("buttonDiv"),
            {size: "large", type: "standard", text: "continue_with", shape: "rect"}  // customization attributes
        );
        // not going to prompt, kinda annoyting
        // google.accounts.id.prompt(); // also display the One Tap dialog
    }, [handleCredentialResponse]);

    React.useEffect(() => {
        if (loading || !authenticationContext.initialLoadDone || authenticationContext.isAuthenticated) return;
        const google = (window as any).google;
        if (!google) {
            // @ts-ignore
            document.getElementById("gsi_client").addEventListener("load", () => {
                executeGoogleSetup((window as any).google);
            });
            return;
        }
        executeGoogleSetup(google);

    }, [authenticationContext.initialLoadDone, authenticationContext.isAuthenticated, executeGoogleSetup, handleCredentialResponse, loading]);

    return (
        <div>
            <div id={"buttonDiv"}></div>
        </div>
    )
}

export default GoogleSignInButton;
